import './App.css';
import { NotesWrapper } from './components/NotesWrapper';

function App() {
  return (
    <div className="App">
      <NotesWrapper/>
    </div>
  );
}

export default App;
